import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import { CookieSettingsButton } from "@xo-union/ui-consent-management";
import BlankButton from "@xo-union/component-blank-button";
import styles from "../../../../../css/index.css";
import FooterLink from "../../FooterLink/index.js";
import CopyrightSection from "../../CopyrightSection/index.js";
import { useTKHost } from "../../HostContext.js";
const BusinessItem = props => /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(FooterLink, _extends({
  className: styles.businessItemBase
}, props)));
const BusinessSection = () => {
  const tkHost = useTKHost();
  return /*#__PURE__*/React.createElement("div", {
    className: styles.businessLinksContainer
  }, /*#__PURE__*/React.createElement("ul", {
    className: styles.businessLinksContainer,
    role: "list"
  }, /*#__PURE__*/React.createElement(BusinessItem, {
    href: `${tkHost}/privacy-policy`
  }, "Privacy policy"), /*#__PURE__*/React.createElement(BusinessItem, {
    href: `${tkHost}/terms-and-conditions`
  }, "Terms of use"), /*#__PURE__*/React.createElement(BusinessItem, {
    href: `${tkHost}/marketplace/AI-terms`
  }, "AI"), /*#__PURE__*/React.createElement(BusinessItem, {
    href: "https://www.theknotww.com/accessibility-statement"
  }, "Accessibility"), /*#__PURE__*/React.createElement(BusinessItem, {
    href: "https://theknotww.zendesk.com/hc/en-us/requests/new?ticket_form_id=360000590371",
    rel: "nofollow"
  }, "Do not sell my info"), /*#__PURE__*/React.createElement(BusinessItem, {
    href: "https://www.theknotww.com/ca-collection-notice/"
  }, "CA privacy"), /*#__PURE__*/React.createElement(BusinessItem, {
    href: "https://images.theknot.com/rules/2024/The-Knot-Rewards-Program-Terms-and-Conditions.pdf"
  }, "The Knot Rewards"), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(CookieSettingsButton, {
    className: styles.cookieSettingsButton
  }, buttonProps => /*#__PURE__*/React.createElement(BlankButton, _extends({
    type: "button"
  }, buttonProps))))), /*#__PURE__*/React.createElement(CopyrightSection, null));
};
export default BusinessSection;